import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useForm } from "react-hook-form";
import Paper from "@mui/material/Paper";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import "../components/Table/Table.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import { allChecklist, checklist_inactive } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Tooltip, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Modal, Button, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";

const AllActivity = ({ role, mainId, userData }) => {
  const [error, setErrors] = useState({});

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const location = useLocation();
  const rowData = location.state;


  useEffect(() => {
    setIsLoading(true);

    // Hardcoded data
    const demoData = [
      {
        id: 1,
        caption: "Creative Arts Showcase: Unleash Your Talent!",
        Description: "Calling all budding artists, performers, and creatives! Get ready to shine at our Creative Arts Showcase. Express yourself through music, dance, drama, and visual arts as we celebrate the power of creativity and self-expression.",
        Date: "2024-06-01",
        File: 1,
        action: 'done',
      },
      {
        id: 2,
        caption: "Activity 2",
        Description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Doloremque, totam.",
        Date: "2024-06-02",
        File: 0,
        action: 'undone'
      },
      {
        id: 3,
        caption: "Activity 3",
        Description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam fugiat ipsa harum, quis optio odit, ducimus quia qui, laborum eligendi illum tempora in inventore quasi." ,
        Date: "2024-06-004",
        File: 5,
        action: 'undone'
      },
      // Add more hardcoded data as needed
    ];

    setFilteredData(demoData);
    setIsLoading(false);
  }, []);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  let navigate = useNavigate();
  const view = (row) => {
    navigate("/add-activity", { state: row });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleImageClick = (imageData) => {
    var w = window.open('about:blank');
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement('iframe')).src = "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = '100%';
      w.document.getElementsByTagName("iframe")[0].style.height = '100%';
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };

  const toggleStatus = (rowId, currentStatus) => {
    setIsLoading(true);
    let data = {
      checklist_id: rowId,
    };
    checklist_inactive(data)
      .then((res) => {
        if (res.status === "success") {
          toast.success(res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
    setIsLoading(false);
  };
  

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 ">
      <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t(" ")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} 
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", 
              }}
            />
          </div>
        </div>
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("All Activities")}</h5>
          <div style={{ display: role == 7 ? "none" : "block" }}>
            <button className="btn btn-primary btn-sm" onClick={() => view()}>
              <AddIcon />
              {t("Add Activity")}
            </button>

          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table  aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Caption")}</TableCell>
                  <TableCell align="center" >{t("Description")}</TableCell>
                  <TableCell align="center">{t("Date")}</TableCell>
                  <TableCell align="center">{t("File")}</TableCell>
                  <TableCell align="center">{t("Action")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {!isLoading &&
                  filteredData
                  .filter((item) =>
                    item.caption.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    item.Description.toLowerCase().includes(searchQuery.toLowerCase())
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row" style={{ width: "7%" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" style={{ width: "20%" }}>
                          {row.caption || ""}
                        </TableCell>
                        <TableCell align="center" style={{ width: "45%" }}>{row.Description || 16}</TableCell>
                        <TableCell align="center"style={{width:"20%"}}>{row.Date}</TableCell>
                        <TableCell align="center"style={{ width: "10%" }}>{row.File || 16}</TableCell>
                        <TableCell align="center" style={{ width: "10%" }}>
                          {row.action}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <h4>
                        <i>No data available</i>
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default AllActivity;
